module.exports = "/images/santander.svg?c2f507296c39c16e2ba089ebc86e4d61";